import { trpc } from '@/shared/api';

export const useInvalidateTaxInvoice = () => {
  const utils = trpc.useUtils();
  return (orderId: string) => utils.taxInvoiceManagement.get.invalidate({ orderId });
};
